import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const token = localStorage.getItem("ep_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setSchool(data.school);
    } catch {
      setUser(false);
      localStorage.removeItem("ep_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const login = async (identifier, password) => {
    // `identifier` is an email address or a mobile number — the backend resolves both.
    const { data } = await api.post("/auth/login", { email: identifier, password });
    localStorage.setItem("ep_token", data.token);
    await loadMe();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ep_token");
    setUser(false);
    setSchool(null);
  };

  return (
    <AuthContext.Provider value={{ user, school, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
